import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Grid, Segment, Popup } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import JobPositionStore from "../../../app/stores/jobpositionStore";
import JobPositionList from "./JobPositionList";

const JobPositionDashboard: React.FC = () => {
  const jobpositionStore = useContext(JobPositionStore);
  const { loadCertificates, loadJobPositions,} = jobpositionStore;

  useEffect(() => {
    loadCertificates().then(() => loadJobPositions());
  }, [jobpositionStore]);

  if (jobpositionStore.loadingInitial)
  return <LoadingComponent content="Loading Positions" />;
  
  return (
    <Segment>
      <Grid>
        <Grid.Column width={8}></Grid.Column>
        <Grid.Column width={5}>
        </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={"/hrmanagement/jobposition-create"}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <JobPositionList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(JobPositionDashboard);
